import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { DELIVERABLES } from '../../data/content';
export function WhatYouGet() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-310" data-mp="143gl44qcsha1">
      <div className="mx-auto max-w-3xl" data-id="element-311" data-mp="1402mn7kt8s7v">
        <Reveal className="text-center" data-id="element-312" data-mp="zzr01p8w0htr">
          <SectionBadge data-id="element-313" data-mp="102wr3a12tts4">Acceso inmediato</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-314" data-mp="1dzjo1ct14jy1">
            ¿Qué recibís <span className="u-lime" data-id="element-315" data-mp="190yx63zo3cm9">después de comprar</span>?
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-8" data-id="element-316" data-mp="1npv3nwm2shkr">
          <div className="overflow-hidden rounded-2xl border border-ink-line bg-ink" data-id="element-317" data-mp="1irbe7m89wnnn">
            <ul className="grid sm:grid-cols-2" data-id="element-318" data-mp="1itnwk0hy1018">
              {DELIVERABLES.map(item => <li key={item} className="flex items-start gap-3 border-b border-ink-line px-5 py-3.5 text-sm font-semibold leading-snug text-snow sm:text-base" data-id="element-319" data-mp="1wrchf8c0g76a">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-320" data-mp="2uzdlb2t6w34t" />
                  {item}
                </li>)}
            </ul>
            <p className="bg-ink-soft px-5 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-lime" data-id="element-321" data-mp="2zzhyojyswhqt">
              Un único pago. Sin suscripciones.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}